export function flightPurchaseCalculation({
  flightPurchaseAirlines,
  flightPurchaseGuests,
  flightPurchaseAddOns,
}) {
  let tempSchedulePrice = 0;
  tempSchedulePrice = (flightPurchaseAirlines || []).reduce(
    (prevAirline, currAirline) =>
      prevAirline + (currAirline.price || 0) * flightPurchaseGuests.length,
    0,
  );
  tempSchedulePrice += (flightPurchaseAddOns || []).reduce(
    (prevAddon, currAddon) => prevAddon + (currAddon.price || 0),
    0,
  );
  return tempSchedulePrice;
}

export function totalFlightPurchaseCalculation({
  flightPurchases,
  discount,
  otherCost,
}) {
  let tempTotal: number = 0;
  tempTotal = flightPurchases.reduce(
    (prev, curr) =>
      prev +
      flightPurchaseCalculation({
        flightPurchaseAddOns: curr.flightPurchaseAddOns,
        flightPurchaseAirlines: curr.flightPurchaseAirlines,
        flightPurchaseGuests: curr.flightPurchaseGuests,
      }),
    0,
  );

  tempTotal -= discount || 0;
  tempTotal += otherCost || 0;
  return tempTotal;
}
